// removed by extract-text-webpack-plugin
module.exports = {"CashTransferHistory":"CashTransferHistory","CellStatusSucess":"CellStatusSucess","CellStatusPending":"CellStatusPending","CellStatusFailed":"CellStatusFailed","CashTransferHistoryFilter":"CashTransferHistoryFilter","TransferTypeDropdown":"TransferTypeDropdown","StatusDropdown":"StatusDropdown","CashTransferHistorySheet":"CashTransferHistorySheet","ag-row-odd":"ag-row-odd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer1/CashTransferHistory/styles.scss
// module id = 838
// module chunks = 10